<template>
  <div :style="'margin-left:'+ value.styleSet.plantingNextMargin + ';margin-right:' + value.styleSet.plantingPreviousMargin">
    <!-- 前边距和后边距的设置 暂时没有 需要单独增加 value.styleSet.plantingNextMargin  value.styleSet.plantingPreviousMargin  -->
    <!--visitSource = 2  PC端 -->
    <div v-if="visitSource == 2" class="PC" :style="value.styleSet.pageFieldRotationBoxStyleSet?value.styleSet.pageFieldRotationBoxStyleSet.styleSetCode:''" kwName="pageFieldRotationBoxStyleSet">
      <el-carousel v-if="(value.childPageJsonArr.length > 0)" class="swiper-container" :arrow="value.styleSet.plantingIndicatorDots ==2 ? 'never':'always'" trigger="click" :height="imgHeight"
                   :indicator-position="value.styleSet.plantingIndicatorDots ==2?'none':'outside'"
      >
        <el-carousel-item v-for="(item,index) in value.childPageJsonArr" :key="'carouse_'+index" style="text-align: center">
          <img v-if="(item.dataInfo.TYPE==2)" ref="imageHeight" class="swiper_imge_pc" :style="value.styleSet.pageFieldRotationCommonStyleSet?value.styleSet.pageFieldRotationCommonStyleSet.styleSetCode:''" kwName="pageFieldRotationCommonStyleSet" :src="(GLOBAL.getFileServeUrl()+item.fieldSet[0].fileList[0].F_MONGOID)" @click="toDetailPage(item)" />
          <video v-else-if="(item.dataInfo.TYPE==3)" oncontextmenu="return false;" class="swiper_imge_pc" :style="value.styleSet.pageFieldRotationCommonStyleSet?value.styleSet.pageFieldRotationCommonStyleSet.styleSetCode:''" kwName="pageFieldRotationCommonStyleSet" controls="controls" :src="(GLOBAL.getFileServeUrl()+item.fieldSet[0].fileList[0].F_MONGOID)"></video>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!--visitSource = 3  移动端 -->
    <div v-else class="kw_carousel" :style="value.styleSet.pageFieldRotationBoxStyleSet?value.styleSet.pageFieldRotationBoxStyleSet.styleSetCode:''" kwName="pageFieldRotationBoxStyleSet">
      <el-carousel v-if="(value.childPageJsonArr.length > 0)" class="swiper-container" :arrow="value.styleSet.plantingIndicatorDots ==2 ? 'never':'always'" trigger="click" :height="imgHeight"
                   :indicator-position="value.styleSet.plantingIndicatorDots ==2?'none':'outside'"
      >
        <el-carousel-item v-for="(item,index) in value.childPageJsonArr" :key="'carouse_'+index" style="text-align: center">
          <img v-if="(item.dataInfo.TYPE==2)" ref="imageHeight" class="swiper_imge" :style="value.styleSet.pageFieldRotationCommonStyleSet?value.styleSet.pageFieldRotationCommonStyleSet.styleSetCode:''" kwName="pageFieldRotationCommonStyleSet" :src="(GLOBAL.getFileServeUrl()+item.fieldSet[0].fileList[0].F_MONGOID)" @click="toDetailPage(item)" />
          <video v-else-if="(item.dataInfo.TYPE==3)" oncontextmenu="return false;" class="swiper_imge" :style="value.styleSet.pageFieldRotationCommonStyleSet?value.styleSet.pageFieldRotationCommonStyleSet.styleSetCode:''" kwName="pageFieldRotationCommonStyleSet" controls="controls" :src="(GLOBAL.getFileServeUrl()+item.fieldSet[0].fileList[0].F_MONGOID)"></video>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_carousel',
  props: {
    value: {
      type: Object,
      value: {}
    },
    previewVisitSource:{
      type:Number,
      default:0
    }
  },
  data() {
    var that = this;
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(that),
      imgHeight:''
    };
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      var _this = this
      setInterval(function(){
        if(_this.$refs.imageHeight){
          if(_this.$refs.imageHeight[0]){
            _this.imgHeight = _this.$refs.imageHeight[0].height+'px'
          }
        }
      }, 500);
    })
  },
  watch:{

  },
  computed:{
  },
  components: {
  },
  methods: {
    toDetailPage(childOne){
      var tableId = childOne.dataInfo.TABLE_ID;
      var pageId = childOne.dataInfo.PAGE_ID;
      var mainId = childOne.dataInfo.CLICK_DATA_ID;
      if (tableId > 0 && pageId > 0 && mainId > 0) {
        var jumpJson = {
          pageId: pageId,
          tableId: tableId,
          mainId: mainId,
          callBackType: 1
        };
        pageUtils.toNewLookPage(this,jumpJson);
      }
      // console.log("e====================",e);
      // console.log("childOne====================", childOne);
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.swiper-container .swiper-wrapper .swiper-slide{border-radius: 10px;}
.swiper_imge {width: 100%;}
.swiper_imge_pc{width: 100%;}
.swiper-container .swiper-slide::before{
    border:5px solid #ff6682;  
}
.swiper-container{background: #fff}
  .kw_carousel{margin: 0 10px}
</style>
